import { mockComponent } from 'bloko/common/setupMockComponents';

export const H1 = mockComponent('H1', null, { withChildren: true });
export const H2 = mockComponent('H2', null, { withChildren: true });
export const H3 = mockComponent('H3', null, { withChildren: true });
export const H4 = mockComponent('H4', null, { withChildren: true });

export const H1Section = mockComponent('H1Section', null, { withChildren: true });
export const H2Section = mockComponent('H2Section', null, { withChildren: true });
export const H3Section = mockComponent('H3Section', null, { withChildren: true });
export const H4Section = mockComponent('H4Section', null, { withChildren: true });

export const H1Promo = mockComponent('H1Promo', null, { withChildren: true });
export const H2Promo = mockComponent('H2Promo', null, { withChildren: true });
export const H3Promo = mockComponent('H3Promo', null, { withChildren: true });
export const H4Promo = mockComponent('H4Promo', null, { withChildren: true });

export const SubHeader = mockComponent('SubHeader', null, { withChildren: true });
